export class TimeUtils {
    // Convert "HH:MM:SS" to total seconds
    static timeStringToSeconds(time: string): number {
      const parts = time.split(':');
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      const seconds = parseInt(parts[2], 10);
      return hours * 3600 + minutes * 60 + seconds;
    }
  
    // Convert total seconds back to "HH:MM:SS"
    static secondsToTimeString(totalSeconds: number): string {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
      ].join(':');
    }
  
    // Sum an array of "HH:MM:SS" time strings
    static sumTimeStrings(times: string[]): string {
      const totalSeconds = times
        .map(time => this.timeStringToSeconds(time))
        .reduce((acc, curr) => acc + curr, 0);
      return this.secondsToTimeString(totalSeconds);
    }
  }
  